import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

// Axios global config
import axios from 'axios'
Vue.prototype.$http = axios

// Initialize app after restoring auth state
function initApp() {
  // Check auth on app start
  const token = localStorage.getItem('access_token')
  if (token) {
    store.commit('auth/SET_TOKEN', token)
    // Fetch user data in background — don't block app mount
    store.dispatch('auth/fetchCurrentUser')
  }

  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
}

initApp()
